import {login, logout, getUserInfo} from '@/api/system/user';
import {setToken, getToken, removeToken, getDoctorId, setDoctorId, removeDoctorId, getDeptId, removeDeptId, getDeptName, removeDeptName} from '@/utils/auth';
import {setDeptId} from '@/api/system/depart' 
const user = {
    state: {
        token: getToken(),
        name: '',
        avatar: '',
        employeeId: getDoctorId(),
        userName: '',
        roles: [],
        permissions: [],
        scope: undefined,
        deptId: getDeptId(),
        deptName: getDeptName(),
        userId: '',
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_NAME: (state, name) => {
            state.name = name;
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar;
        },
        SET_EMPLOYEEID: (state, employeeId) => {
            state.employeeId = employeeId
        },
        SET_USERNAME: (state, userName) => {
            state.userName = userName
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_PERMISSIONS: (state, permissions) => {
            state.permissions = permissions
        },
        SET_SCOPE: (state, scope) => {
            state.scope = scope
        },
        SET_DEPTID: (state, deptId) => {
            state.deptId = deptId
        },
        SET_DEPTNAME: (state, deptName) => {
            state.deptName = deptName
        },
        SET_USERID: (state, userId) => {
            state.userId = userId
        }
    },
    actions: {
        Login({commit, state}, userInfo) {
            const username = userInfo.loginName.trim()
            const password = userInfo.password
            return new Promise((resolve, reject) => {
                login(username, password).then(res => {
                    setToken(res.data.token)
                    setDoctorId(res.data.employeeId)
                    commit('SET_TOKEN', res.data.token);
                    commit('SET_EMPLOYEEID', res.data.employeeId);
                    setDeptId(state.deptId)
                    resolve()
                }).catch(error => {
                    console.log(error)
                    reject(error)
                })
            })
        },
        // 退出系统
        LogOut({commit, state}) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_NAME', []);
                    commit('SET_EMPLOYEEID', []);
                    commit('SET_ROLES', [])
                    commit('SET_PERMISSIONS', [])
                    removeToken()
                    removeDoctorId()
                    removeDeptId()
                    removeDeptName()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetInfo({commit, state}) {
            return new Promise((resolve, reject) => {
                getUserInfo({id: state.employeeId}).then(res => {
                    const user = res.data.employee
                    const avatar = (user.imageUrl == "" || user.imageUrl == null) ? require("@/assets/images/profile.jpg") : user.imageUrl;
                    if (res.data.roles && res.data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                        commit('SET_ROLES', res.data.roles)
                        commit('SET_PERMISSIONS', res.data.permissions)
                    } else {
                        commit('SET_ROLES', ['ROLE_DEFAULT'])
                    }
                    commit('SET_USERID', user.userId)
                    commit('SET_USERNAME', user.username)
                    commit('SET_SCOPE', user.scope)
                    commit('SET_NAME', user.name)
                    commit('SET_AVATAR', avatar)
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }
    }
}

export default user;